import * as React from "react";
import { SlidersHorizontal } from "lucide-react";
import { Button } from "../ui/button";
import { Popover } from "../ui/popover";
import { ReviewSearchField } from "./ReviewSearchField";
import { ignorePopoverFocusOutOnChange } from "./ignorePopoverFocusOut";
import { cn } from "@/lib/utils";

type ReviewListFiltersBarProps = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  activeFilterCount?: number;
  filterOpen?: boolean;
  onFilterOpenChange?: (open: boolean) => void;
  filterContent: React.ReactNode;
  filterLabel?: string;
  className?: string;
};

export function ReviewListFiltersBar({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  activeFilterCount = 0,
  filterOpen,
  onFilterOpenChange,
  filterContent,
  filterLabel,
  className,
}: ReviewListFiltersBarProps) {
  return (
    <div className={cn("flex items-center gap-2 w-full min-w-0", className)}>
      <ReviewSearchField value={searchValue} onChange={onSearchChange} placeholder={searchPlaceholder} />
      <Popover open={filterOpen} onOpenChange={ignorePopoverFocusOutOnChange(open => onFilterOpenChange?.(open))}>
        <Popover.Trigger>
          <Button
            type="button"
            variant={activeFilterCount > 0 ? "default" : "outline"}
            size={filterLabel ? "sm" : "icon-sm"}
            title="Toggle advanced filters"
            className={cn("h-9 relative shrink-0", filterLabel ? "w-9 px-0 md:w-auto md:px-3" : "w-9")}
            aria-label="Filters"
          >
            <SlidersHorizontal className="h-4 w-4" />
            {filterLabel ? <span className="hidden md:inline">{filterLabel}</span> : null}
            {activeFilterCount > 0 ? (
              <span className="absolute -top-1.5 -right-1.5 bg-red-500 text-white text-[9px] font-extrabold h-4 w-4 rounded-full flex items-center justify-center ring-2 ring-white">
                {activeFilterCount}
              </span>
            ) : null}
          </Button>
        </Popover.Trigger>
        {filterContent}
      </Popover>
    </div>
  );
}
